import { Button, KIND, SIZE, SHAPE } from 'baseui/button';
import merge from 'lodash/merge';
import size from 'lodash/size';
import { pure, compose } from 'recompose';
import Plus from 'baseui/icon/plus';
import React from 'react';
import type { QnAStateType } from '../reducers';
import { QuestionStyleContext, defaultQuestionStyles } from '../question-style-context';
import { getTopQuestionIds } from '../reducers/selectors';
import ModalCopyQuestion from './common/ModalCopyQuestion';
import Question from './compose/Question';
import QuestionList from './common/QuestionList';
const ComposeQuestions = ({
  state,
  updateQuestion,
  addQuestion,
  addConditionalQuestion,
  setModal,
  removeQuestion,
  styleOverrides
}: {
  state: QnAStateType;
  updateQuestion: Function;
  addQuestion: Function;
  addConditionalQuestion: Function;
  setModal: Function;
  removeQuestion: Function;
  styleOverrides: any;
}) => {
  const topQuestionIds = getTopQuestionIds(state);
  const styles = merge({}, defaultQuestionStyles, styleOverrides);
  const {
    disableCopyQuestion
  } = styles;
  return <QuestionStyleContext.Provider value={styles}>
      <QuestionList>
        {topQuestionIds.map((id, idx) => {
        return <Question key={`questionid-${id}`} questionId={id} state={state} updateQuestion={updateQuestion} addQuestion={addQuestion} addConditionalQuestion={addConditionalQuestion} setModal={setModal} removeQuestion={removeQuestion} />;
      })}
      </QuestionList>
      <Button kind={KIND.secondary} size={SIZE.compact} shape={SHAPE.pill} onClick={e => {
      addQuestion();
    }}>
        <Plus /> Top Level Question
      </Button>{' '}
      {!disableCopyQuestion && <Button disabled={size(topQuestionIds) < 1} kind={KIND.secondary} size={SIZE.compact} shape={SHAPE.pill} onClick={e => {
      setModal('copy', {
        open: true
      });
    }}>
          <Plus /> Copy Question
        </Button>}
      <ModalCopyQuestion state={state} setModal={setModal} addQuestion={addQuestion} />
    </QuestionStyleContext.Provider>;
};
export default compose(pure)(ComposeQuestions);